import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69fa13e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"height":"485px","overflow":"auto"},
  class: "base-info"
}
const _hoisted_2 = {
  key: 0,
  style: { fontSize: '16px', color: 'red' }
}
const _hoisted_3 = { class: "download-img" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("下载文件")
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { class: "download-img" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("下载文件")
const _hoisted_9 = { key: 4 }
const _hoisted_10 = { class: "download-img" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("下载文件")
const _hoisted_12 = { class: "feed-back" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "反馈", -1))
const _hoisted_14 = { class: "footer" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("批准")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("拒绝")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("下载文件")
const _hoisted_19 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_CloseCircleOutlined = _resolveComponent("CloseCircleOutlined")!
  const _component_image_preview = _resolveComponent("image-preview")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_descriptions, {
        column: 1,
        bordered: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_descriptions_item, { label: "车架号：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.data.vinNo), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_descriptions_item, { label: "车型：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.data.model), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_descriptions_item, { label: "发票日期：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.data.invoiceDate), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_descriptions_item, { label: "上牌日期：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.data.licenseDate), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_descriptions_item, { label: "发票价格（不含税）：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.data.price), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_descriptions_item, { label: "客户姓名：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.data.customerName), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_descriptions_item, { label: "零售类型：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.data.usage), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_descriptions_item, { label: "系统自动检查失败原因：" }, {
            default: _withCtx(() => [
              (_ctx.data.sysAutoCheckFailReason !== '')
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _createVNode(_component_CloseCircleOutlined),
                    _createTextVNode(" " + _toDisplayString(_ctx.data.sysAutoCheckFailReason), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_a_descriptions_item, { label: "提交状态：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.EnumApprovalStatus[_ctx.data.approlStatus]), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_descriptions_item, { label: "激励适用性：" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.EnumCheckStatus[_ctx.data.checkStatus]), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_descriptions_item, { label: "附件列表：" }, {
            default: _withCtx(() => [
              (_ctx.data.attachFiles.length > 0 && _ctx.data.attachFiles[0].docType !== 'PDF')
                ? (_openBlock(), _createBlock(_component_a_popover, {
                    key: 0,
                    placement: "rightTop"
                  }, {
                    content: _withCtx(() => [
                      _createVNode(_component_image_preview, {
                        width: 200,
                        src: _ctx.data.attachFiles[0].preSignedUrl
                      }, null, 8, ["src"]),
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_a_button, {
                          key: "submit",
                          type: "primary",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadImg(_ctx.data.attachFiles[0].name, _ctx.data.attachFiles[0].preSignedUrl)))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, { type: "link" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.data.attachFiles[0].name), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.data.attachFiles.length > 0 && _ctx.data.attachFiles[0].docType === 'PDF')
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    type: "link",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => {
            _ctx.pdfShow = true;
            _ctx.pdfObj = _ctx.data.attachFiles[0];
          })
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.data.attachFiles[0].name), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.data.attachFiles.length > 1)
                ? (_openBlock(), _createElementBlock("br", _hoisted_5))
                : _createCommentVNode("", true),
              (_ctx.data.attachFiles.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_ctx.data.attachFiles[1].docType !== 'PDF')
                      ? (_openBlock(), _createBlock(_component_a_popover, {
                          key: 0,
                          placement: "rightTop"
                        }, {
                          content: _withCtx(() => [
                            _createVNode(_component_image_preview, {
                              width: 200,
                              src: _ctx.data.attachFiles[1].preSignedUrl
                            }, null, 8, ["src"]),
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_a_button, {
                                key: "submit",
                                type: "primary",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.downloadImg(_ctx.data.attachFiles[1].name, _ctx.data.attachFiles[1].preSignedUrl)))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_8
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, { type: "link" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.data.attachFiles[1].name), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.data.attachFiles.length > 1 && _ctx.data.attachFiles[1].docType === 'PDF')
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 1,
                          type: "link",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => {
              _ctx.pdfShow = true;
              _ctx.pdfObj = _ctx.data.attachFiles[1];
            })
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.data.attachFiles[1].name), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.data.attachFiles.length > 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_ctx.data.attachFiles[2].docType !== 'PDF')
                      ? (_openBlock(), _createBlock(_component_a_popover, {
                          key: 0,
                          placement: "rightTop"
                        }, {
                          content: _withCtx(() => [
                            _createVNode(_component_image_preview, {
                              width: 200,
                              src: _ctx.data.attachFiles[2].preSignedUrl
                            }, null, 8, ["src"]),
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_a_button, {
                                key: "submit",
                                type: "primary",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.downloadImg(_ctx.data.attachFiles[2].name, _ctx.data.attachFiles[2].preSignedUrl)))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_11
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, { type: "link" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.data.attachFiles[2].name), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.data.attachFiles.length > 2 && _ctx.data.attachFiles[2].docType === 'PDF')
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 1,
                          type: "link",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => {
              _ctx.pdfShow = true;
              _ctx.pdfObj = _ctx.data.attachFiles[2];
            })
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.data.attachFiles[2].name), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("section", _hoisted_12, [
        _hoisted_13,
        _createVNode(_component_a_table, {
          columns: _ctx.columns,
          "data-source": _ctx.data.failReasonReplyList,
          scroll: { y: 150 },
          rowKey: "id",
          pagination: false
        }, null, 8, ["columns", "data-source"])
      ])
    ]),
    _createElementVNode("section", _hoisted_14, [
      _createVNode(_component_a_button, {
        class: "button",
        onClick: _ctx.approvalEvent
      }, {
        default: _withCtx(() => [
          _hoisted_15
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_a_button, {
        type: "primary",
        class: "button",
        onClick: _ctx.rejectEvent
      }, {
        default: _withCtx(() => [
          _hoisted_16
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.isOpenRejectModal,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isOpenRejectModal) = $event)),
      title: "编辑内容",
      onOk: _ctx.handleOk,
      centered: ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.saveEvent,
          disabled: _ctx.rejectContent === '',
          loading: _ctx.saveLoading
        }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        }, 8, ["onClick", "disabled", "loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_textarea, {
          value: _ctx.rejectContent,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.rejectContent) = $event)),
          placeholder: "请输入",
          onInput: _ctx.scrollBottomEvent,
          "auto-size": { minRows: 4, maxRows: 8 }
        }, null, 8, ["value", "onInput"])
      ]),
      _: 1
    }, 8, ["visible", "onOk"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.pdfShow,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.pdfShow) = $event)),
      title: _ctx.pdfObj.name,
      onCancel: _cache[9] || (_cache[9] = ($event: any) => (_ctx.pdfShow = false)),
      width: "100%",
      bodyStyle: { height: '450px' }
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.downloadFile
        }, {
          default: _withCtx(() => [
            _hoisted_18
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("iframe", {
          src: _ctx.pdfObj.base64,
          frameborder: "0"
        }, null, 8, _hoisted_19)
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ], 64))
}